
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/board/detail/[id]",
      function () {
        return require("private-next-pages/community/board/detail/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/board/detail/[id]"])
      });
    }
  